import * as React from "react";
import { Fun, IOWidget, mk_widget, option, Options } from "../widget";

interface DropdownProps<a> {
  options?:Options,
  selected?:a,
  input:a[],
  to_string:Fun<a,string>,
  on_done:(output:a | undefined) => void
}
interface DropdownState<_a> { }

class Dropdown<a> extends React.Component<DropdownProps<a>, DropdownState<a>> {
  constructor(props:DropdownProps<a>, context:any) {
    super(props, context)

    this.state = {}
  }

  render() {
    return <select  value={this.props.selected ? this.props.to_string(this.props.selected) : ""}
                    id={option("id", this.props.options)}
                    onChange={e => {
                      for (let i = 0; i < e.currentTarget.selectedOptions.length; i++) {
                        let option = e.currentTarget.selectedOptions[i]
                        for (let j = 0; j < this.props.input.length; j++) {
                          if (this.props.to_string(this.props.input[j]) == option.value) {
                            return this.props.on_done(this.props.input[j])
                          }
                        }
                      }
                      return this.props.on_done(undefined)
                    } }>
      <option key={`__internal__selector-empty-element`} value="" disabled={true} style={{"display":"none"}}></option>
      {
        this.props.input.map(a =>
          <option key={this.props.to_string(a)} value={this.props.to_string(a)}>{this.props.to_string(a)}</option>
        )
      }
    </select>
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const dropdown = function<a>(to_string:Fun<a,string>, input:a[], options?:Options) : IOWidget<a|undefined, a | undefined> {
  return (selected) => mk_widget({
    run:(on_done:(output:a | undefined) => void) =>
      React.createElement<DropdownProps<a>>(Dropdown, { on_done, input, selected, to_string, options })
  })
}
